export class BankDetailsData {
  constructor(
    id = "",
    bank_name = "",
    bank_account = "",
    bank_account_holder_name = "",
    branch_name = "",
    ifsc_code = "",
    qr_code_image = ""
  ) {
    this.id = id;
    this.bank_name = bank_name;
    this.bank_account = bank_account;
    this.bank_account_holder_name = bank_account_holder_name;
    this.branch_name = branch_name;
    this.ifsc_code = ifsc_code;
    this.qr_code_image = qr_code_image;
  }
}
